import React from "react";

import { Checkbox } from "@material-ui/core";
import { getIn } from "formik";

import { withNamespace } from "components/Form/FormikControls";

import { SchemaFieldDataSource } from "containers/Settings/RuleBooks/DataSource/SchemaFieldDataSource";
import { normalisePathParts } from "containers/Settings/RuleBooks/Schema/schema";
import { useRuleFieldSchema } from "containers/Settings/RuleBooks/Schema/schemaContext";

import { useFieldState, useFieldValue } from "hooks";

import { CheckGroups } from "./CheckGroups";

export function Criterion(props) {
  const {
    criteriaOptions,
    criteriaIndex,
    namespace: ns,
    ruleInputPath,
    parentInputPath,
    showPrerequisiteRuleSource,
    readOnly,
  } = props;
  const criterion = useFieldValue(ns);

  const queryPath = getIn(criterion, "query.value");

  const schema = useRuleFieldSchema();

  const [isUsingRelatedQueryData, setIsUsingRelatedQueryData] = useFieldState(
    withNamespace(ns, "query"),
  );

  const fullPath = normalisePathParts([parentInputPath, ruleInputPath]);

  const checkFieldPath = normalisePathParts([ruleInputPath, queryPath]);

  function onChangeCheckUsingQueryData(event) {
    setIsUsingRelatedQueryData(event.target.checked);
  }

  return (
    <div>
      <p>
        <Checkbox
          type="checkbox"
          name={withNamespace(ns, "usingQueryData")}
          onChange={onChangeCheckUsingQueryData}
          checked={Boolean(isUsingRelatedQueryData)}
          disabled={readOnly}
        />{" "}
        {!isUsingRelatedQueryData ? (
          "(not using related data)"
        ) : (
          <>
            when related{" "}
            <SchemaFieldDataSource
              namespace={withNamespace(ns, "query")}
              fieldPath={fullPath}
              showRelations
              allowSelectManyRelations
              showManyRelations
              schema={schema}
              readOnly={readOnly}
            />
            {criterion?.checkGroups.length === 0 && " exist."}
          </>
        )}
        {criterion?.checkGroups.length > 0 && " meet the following conditions:"}
      </p>
      <CheckGroups
        criteriaOptions={criteriaOptions}
        criteriaIndex={criteriaIndex}
        namespace={withNamespace(ns, "checkGroups")}
        checkFieldPath={checkFieldPath}
        parentInputPath={parentInputPath}
        showPrerequisiteRuleSource={showPrerequisiteRuleSource}
        readOnly={readOnly}
      />
    </div>
  );
}
